import qs from "qs";

import {
  fetchRequest,
  reactQueryGet,
  reactQueryPost,
  serializeJsonResponse,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

import type {
  ShowEndpointQueryParams,
  ShowResponseEndpoint,
  VerificationsCreateParams,
  VerificationsCreateResponse,
} from "./paywallCheckoutApi.types";

export interface PaywallCheckoutError {
  error_details?: any;
  message: string;
}

const preview = async ({
  queryParams,
  shouldIgnoreCommunityMember,
  locale,
}: any) => {
  const previewUrl = `${internalApi.paywallCheckout.preview()}${qs.stringify({
    checkout: queryParams,
    ...(locale ? { locale } : {}),
  })}`;

  const response = await fetch(previewUrl, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    credentials: shouldIgnoreCommunityMember ? "omit" : "same-origin",
  });

  return serializeJsonResponse(response);
};

const prepare = (
  communityId: number,
  paywallPriceId: number,
  checkoutIntentToken?: string,
) =>
  fetchRequest<Response>(internalApi.paywallCheckout.prepare(), {
    method: "POST",
    body: JSON.stringify({
      checkout: {
        community_id: communityId,
        paywall_price_id: paywallPriceId,
        checkout_intent_token: checkoutIntentToken,
      },
    }),
  });

const create = ({ formData }: any) =>
  fetchRequest<Response>(internalApi.paywallCheckout.create(), {
    method: "POST",
    body: JSON.stringify({ checkout: formData }),
  });

const show = (queryParams: ShowEndpointQueryParams) =>
  reactQueryGet<ShowResponseEndpoint>(
    internalApi.paywallCheckout.show({ params: queryParams }),
  );

const verificationsCreate = (params: VerificationsCreateParams) =>
  reactQueryPost<VerificationsCreateResponse>(
    internalApi.paywallCheckout.verifications.create(params),
  );

export const paywallCheckoutApi = {
  preview,
  prepare,
  create,

  show,

  verifications: {
    create: verificationsCreate,
  },
};
